var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "4102579_applications_instagram_media_social_icon 4",
    clipPath: "url(#clip0_0_3706)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3-instagram"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.25 30L24.75 30C27.6495 30 30 27.6495 30 24.75L30 5.25C30 2.35051 27.6495 0 24.75 0L5.25 0C2.35051 0 0 2.35051 0 5.25L0 24.75C0 27.6495 2.35051 30 5.25 30Z",
    fill: "url(#paint0_radial_0_3706)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.625 26.25H9.375C7.88316 26.25 6.45242 25.6574 5.39752 24.6025C4.34263 23.5476 3.75 22.1168 3.75 20.625V9.375C3.75 7.88316 4.34263 6.45242 5.39752 5.39752C6.45242 4.34263 7.88316 3.75 9.375 3.75H20.625C22.1168 3.75 23.5476 4.34263 24.6025 5.39752C25.6574 6.45242 26.25 7.88316 26.25 9.375V20.625C26.25 22.1168 25.6574 23.5476 24.6025 24.6025C23.5476 25.6574 22.1168 26.25 20.625 26.25ZM9.375 6C8.48028 6.00124 7.62255 6.35722 6.98988 6.98988C6.35722 7.62255 6.00124 8.48028 6 9.375V20.625C6.00124 21.5197 6.35722 22.3774 6.98988 23.0101C7.62255 23.6428 8.48028 23.9988 9.375 24H20.625C21.5197 23.9988 22.3774 23.6428 23.0101 23.0101C23.6428 22.3774 23.9988 21.5197 24 20.625V9.375C23.9988 8.48028 23.6428 7.62255 23.0101 6.98988C22.3774 6.35722 21.5197 6.00124 20.625 6H9.375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15 21.375C13.7391 21.375 12.5066 21.0011 11.4582 20.3006C10.4099 19.6001 9.59278 18.6045 9.11027 17.4396C8.62776 16.2747 8.50152 14.9929 8.7475 13.7563C8.99348 12.5197 9.60064 11.3838 10.4922 10.4922C11.3838 9.60064 12.5197 8.99348 13.7563 8.7475C14.9929 8.50152 16.2747 8.62776 17.4396 9.11027C18.6045 9.59278 19.6001 10.4099 20.3006 11.4582C21.0011 12.5066 21.375 13.7391 21.375 15C21.3738 16.6904 20.7017 18.3112 19.5064 19.5064C18.3112 20.7017 16.6904 21.3738 15 21.375ZM15 10.875C14.1842 10.875 13.3866 11.1169 12.7083 11.5702C12.0299 12.0235 11.5012 12.6677 11.189 13.4214C10.8768 14.1752 10.7951 15.0046 10.9543 15.8047C11.1134 16.6049 11.5063 17.3399 12.0832 17.9168C12.6601 18.4937 13.3951 18.8866 14.1953 19.0457C14.9954 19.2049 15.8248 19.1232 16.5786 18.811C17.3323 18.4988 17.9766 17.9701 18.4298 17.2917C18.8831 16.6134 19.125 15.8159 19.125 15C19.1238 13.9064 18.6888 12.8579 17.9154 12.0846C17.1421 11.3112 16.0936 10.8762 15 10.875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M21.375 10.125C21.9963 10.125 22.5 9.62132 22.5 9C22.5 8.37868 21.9963 7.875 21.375 7.875C20.7537 7.875 20.25 8.37868 20.25 9C20.25 9.62132 20.7537 10.125 21.375 10.125Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_0_3706",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-0.603514 29.3906) rotate(180) scale(69.2789)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9ED32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#EE2A7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#D22A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#8B2AB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#1B2AF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#002AFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_3706"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.ed1045ebcc1fb8c666cce00d27966757.svg";
export { ForwardRef as ReactComponent };